import Collection from "../../../../../../../../core/data-structures/collection";
import TemplateData from "./template-data";


export class TemplateDataCollection extends Collection<TemplateData> {

    constructor(models: TemplateData[]) {
        super(models);
    }

    static initFromJson(data: JSONArray) {

        const collection = new TemplateDataCollection([]);

        _.map(data, (value, key) => {
            collection.add(new TemplateData(value));
        })

        return collection;
    }

}
